import { Flex, FlexProps } from "@chakra-ui/react";
import React from "react";

interface AiInterviewerSectionProps extends FlexProps {
  children: React.ReactNode;
}

const AiInterviewerSection: React.FC<AiInterviewerSectionProps> = ({
  children,
  ...rest
}) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="flex-start"
      p="6"
      pt="5"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      {...rest}
    >
      {children}
    </Flex>
  );
};

export default AiInterviewerSection;
